<template>
  <div class="onboarding-block-wrapper">
    <div class="onboarding-block-container">
      <div class="onboarding-block-title">基本信息很重要，千万不要填错哦~</div>
      <el-form ref="formRef" :model="form" :rules="rules" class="onboarding-profile-form">
        <el-form-item prop="username">
          <div class="desc-title">姓名<span>*</span></div>
          <el-input
            :value="form.username"
            placeholder="请输入姓名"
            style="margin-bottom: 20px"
            @input="change($event, 'username')"
          />
        </el-form-item>
        <el-form-item prop="phone">
          <div class="desc-title">电话<span>*</span></div>
          <el-input
            :value="form.phone"
            placeholder="请输入电话"
            style="margin-bottom: 20px"
            @input="change($event, 'phone')"
          />
        </el-form-item>
        <el-form-item prop="email">
          <div class="desc-title">邮箱<span>*</span></div>
          <el-input
            :value="form.email"
            placeholder="请输入邮箱"
            style="margin-bottom: 20px"
            @input="change($event, 'email')"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OnboardingProfile',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rules: {
        username: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
            message: '邮箱格式不正确',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    change(value, key) {
      this.$emit('confirm', value, key);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
.onboarding-block-container {
  width: 622px;
  margin-left: 64px;
  padding-bottom: 0 !important;
  .onboarding-block-title {
    font-size: 16px;
    color: #fff;
    margin-bottom: 20px;
  }
  .desc-title {
    font-size: 12px;
    line-height: 12px;
    color: #9a9ca2;
    @apply flex items-center;
    margin-bottom: 12px;
    span {
      color: #ff6644;
      margin-left: 4px;
      line-height: 12px;
    }
  }
  .onboarding-profile-form {
    .el-form-item {
      margin-bottom: 0;
      :deep(.el-form-item__content) {
        line-height: 0;
        .el-form-item__error {
          bottom: 4px;
          top: auto;
        }
      }
    }
  }
  .el-input {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid transparent;
    &:hover,
    &:has(input:focus) {
      background-image: linear-gradient(90deg, #303336, #303336),
        linear-gradient(180deg, #ff3d11, #ff9b19 191%);
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      border: 1px solid transparent;
    }
    :deep(.el-input__inner) {
      background-color: #404148;
      color: #fff;
      font-weight: 500;
      height: 40px;
      border: none;
      &::placeholder {
        color: #9a9ca2;
      }
    }
  }
}
</style>
